<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="badges">
    <div
      class="badge"
      *ngFor="let badge of badges"
      [appStoryblok]="badge._editable"
      appTooltip
      [tooltipHtmlContent]="badge.tooltip | storyblokRichText"
      [skipDelay]="true"
      [toolTipOrigin]="'top'"
      [tooltipStyle]="'light'"
    >
      <img [src]="badge.image?.filename | storyblokCdn" width="32" height="32" alt="" />
      <div class="badge-content">{{ badge.text }}</div>
      <div class="empty small" *ngIf="!badge.text">EMPTY BADGE</div>
    </div>
  </div>
  <div class="empty" *ngIf="badges && !badges.length">EMPTY BADGE LIST</div>
</app-block-wrapper>
